import { memo } from "react";
import Grid from "@mui/material/Grid";
import type { PaymentMethod } from "features/paymentMethods/types";
import { Collection } from "ui/support/Resource";
import { NoDataOverlay } from "ui/molecules/TableGrids";

const MerchantsEnable = ({ enabledOnMerchants }: PaymentMethod) => {
    const merchantNames = Object.values({
        ...enabledOnMerchants
    });

    return (
        <Grid
            sx={{
                width: '100%'
            }}
            container
            spacing={2}
        >
            <Collection
                sx={{
                    flexGrow: 1
                }}
                collection={merchantNames}
                isEmpty={!merchantNames.length}
                emptySlot={(
                    <NoDataOverlay
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 5,
                            px: 2
                        }}
                    >
                        Currently no merchant is enabled for this payment method
                    </NoDataOverlay>
                )}
                renderResource={(name, index) => (
                    <Grid
                        key={index}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                    >
                        {name}
                    </Grid>
                )}
            />
        </Grid>
    );
};

export default memo(MerchantsEnable);
